import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const LOGO_URL = 'https://customer-assets-jai6qajn.emergentagent.net/job_be6b6d40-04a2-4626-96b0-39ae7bcf5dea/artifacts/wk1w9zwb_logo.jpg'

const legal = {
  privacidad: {
    title: 'Política de Privacidad',
    content: `
**Responsable del tratamiento**
José Osuna · jose.osuna.1993@gmail.com

**Datos que recopilamos**
Solo los que tú nos facilitas voluntariamente a través del formulario de contacto: nombre y dirección de email.

**Finalidad**
Atender tu consulta y ponernos en contacto contigo para informarte sobre nuestros servicios de diseño web.

**Base legal**
Tu consentimiento expreso al enviar el formulario.

**Conservación**
Conservamos tus datos solo el tiempo necesario para gestionar tu consulta y, si llega a haber una relación comercial, el tiempo exigido por la normativa fiscal aplicable.

**Derechos**
Puedes ejercer tus derechos de acceso, rectificación, supresión, portabilidad y oposición escribiendo a jose.osuna.1993@gmail.com.

**No cedemos tus datos a terceros** salvo obligación legal.

**Reclamaciones**
Puedes presentar reclamaciones ante la Agencia Española de Protección de Datos (www.aepd.es).
    `
  },
  legal: {
    title: 'Aviso Legal',
    content: `
**Titular del sitio web**
José Osuna · Diseñador Web Freelance
Córdoba, España
jose.osuna.1993@gmail.com

**Objeto**
Este sitio web es un portfolio profesional para la prestación de servicios de diseño web.

**Propiedad intelectual**
Todos los contenidos de este sitio web (textos, fotografías, diseños, logotipos) son propiedad de José Osuna o cuentan con licencia de uso. Queda prohibida su reproducción sin autorización expresa.

**Responsabilidad**
José Osuna no se hace responsable de los daños que pudieran derivarse del uso incorrecto de este sitio web.

**Legislación aplicable**
Las presentes condiciones se rigen por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales de Córdoba.
    `
  },
  cookies: {
    title: 'Política de Cookies',
    content: `
**¿Qué son las cookies?**
Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo al visitar una web.

**Cookies que usamos**
Este sitio web no utiliza cookies de terceros ni de seguimiento. Únicamente usamos una cookie técnica de sesión para recordar tu preferencia de cookies (localStorage), que se borra al cerrar el navegador.

**No utilizamos** Google Analytics, Facebook Pixel ni ningún otro servicio de rastreo publicitario.

**¿Cómo desactivar las cookies?**
Puedes configurar tu navegador para rechazar todas las cookies. Ten en cuenta que esto podría afectar al funcionamiento del sitio.

**Más información**
Para más información sobre cookies: www.aepd.es
    `
  }
}

function LegalContent({ text }) {
  return (
    <div className="text-white/60 leading-relaxed space-y-4" style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: '15px' }}>
      {text.trim().split('\n').map((line, i) => {
        if (line.startsWith('**') && line.endsWith('**')) {
          return <h4 key={i} className="text-white font-bold mt-6 first:mt-0" style={{ fontFamily: 'Anton, sans-serif', letterSpacing: '0.02em', fontSize: '16px' }}>{line.replace(/\*\*/g, '')}</h4>
        }
        if (!line.trim()) return null
        return <p key={i}>{line}</p>
      })}
    </div>
  )
}

export default function LegalModal({ type, onClose }) {
  const data = legal[type]
  if (!data) return null

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-[60] bg-black/95 backdrop-blur-md overflow-y-auto"
      onClick={onClose}
    >
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 20, opacity: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl mx-auto px-6 md:px-12 py-16"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-12">
          <h2 className="text-white uppercase" style={{ fontFamily: 'Anton, sans-serif', fontSize: 'clamp(24px, 3vw, 44px)', letterSpacing: '0.02em', lineHeight: 1 }}>
            {data.title}
          </h2>
          <button
            onClick={onClose}
            data-testid={`close-legal-${type}`}
            className="text-white/40 hover:text-white transition-colors text-xs tracking-[0.3em] uppercase bg-transparent border-0 mt-2 ml-8"
            style={{ fontFamily: 'JetBrains Mono, monospace' }}
          >
            Cerrar ×
          </button>
        </div>
        <div className="border-t border-neutral-900 pt-8">
          <LegalContent text={data.content} />
        </div>
      </motion.div>
    </motion.div>
  )
}
